// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@keyframes rotate360 {\n100% {\r\n    transform: rotate(360deg);\n}\n}\r\n", ""]);
// Exports
module.exports = exports;
